import React from 'react';
import { Ban } from 'lucide-react';

export type ReservationFormActionsProps = {
  isEditing: boolean;
  isSaving: boolean;
  saveDisabled: boolean;
  saveTitle: string;
  onCancelClick: () => void;
};

export default function ReservationFormActions({
  isEditing,
  isSaving,
  saveDisabled,
  saveTitle,
  onCancelClick,
}: ReservationFormActionsProps) {
  return (
    <div className="reservation-form-actions">
      {isEditing && (
        <button
          type="button"
          className="reservation-form-btn reservation-form-btn-delete"
          onClick={onCancelClick}
        >
          <Ban size={16} />
          Cancelar Reserva
        </button>
      )}

      <button
        type="submit"
        className="reservation-form-btn reservation-form-btn-save"
        disabled={saveDisabled}
        title={saveTitle}
      >
        {isSaving ? 'Salvando...' : (isEditing ? 'Atualizar Reserva' : 'Criar Reserva')}
      </button>
    </div>
  );
}
